<script>
  // TODO: Discuss its necessity
  export default {
    name: "DpMobileFileDownload",
    props: {
      fileName: {type: String, required: true},
      fileExtension: {type: String, required: true},
      fileLink: {type: String, required: true}
    }
  }
</script>

<template>
  <div class="dp-flex partition outlined">
    <div class="flex-basis-1">
      <DpFileIcon :file-extension="fileExtension"/>
    </div>
    <div class="flex-basis-1">
      <span class="block file-name">{{fileName}}</span>
      <slot name="info"></slot>
      <span class="block"><a :href="link" target="_blank">{{$t('download.label')}}</a></span>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .block {
    display: block;
  }
  .file-name {
    font-size: 1.2em;
  }
</style>

<i18n>
  {
  "en-US": {
  }
  }
</i18n>
